// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const TestingInstructionPipelineSchema = z.enum(['SIGNAL_GENERATION','SECURITY_TEST_CASE','ATTACK','DISCOVERY','PROBING'] as const);

export type TestingInstructionPipelineType = `${z.infer<typeof TestingInstructionPipelineSchema>}`

export default TestingInstructionPipelineSchema;
